"use strict";
// automatically generated by the FlatBuffers compiler, do not modify
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SerialDevicePortT = exports.SerialDevicePort = void 0;
const flatbuffers = __importStar(require("flatbuffers"));
class SerialDevicePort {
    constructor() {
        this.bb = null;
        this.bb_pos = 0;
    }
    __init(i, bb) {
        this.bb_pos = i;
        this.bb = bb;
        return this;
    }
    static getRootAsSerialDevicePort(bb, obj) {
        return (obj || new SerialDevicePort()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
    }
    static getSizePrefixedRootAsSerialDevicePort(bb, obj) {
        bb.setPosition(bb.position() + flatbuffers.SIZE_PREFIX_LENGTH);
        return (obj || new SerialDevicePort()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
    }
    port(optionalEncoding) {
        const offset = this.bb.__offset(this.bb_pos, 4);
        return offset ? this.bb.__string(this.bb_pos + offset, optionalEncoding) : null;
    }
    static startSerialDevicePort(builder) {
        builder.startObject(1);
    }
    static addPort(builder, portOffset) {
        builder.addFieldOffset(0, portOffset, 0);
    }
    static endSerialDevicePort(builder) {
        const offset = builder.endObject();
        return offset;
    }
    static createSerialDevicePort(builder, portOffset) {
        SerialDevicePort.startSerialDevicePort(builder);
        SerialDevicePort.addPort(builder, portOffset);
        return SerialDevicePort.endSerialDevicePort(builder);
    }
    unpack() {
        return new SerialDevicePortT(this.port());
    }
    unpackTo(_o) {
        _o.port = this.port();
    }
}
exports.SerialDevicePort = SerialDevicePort;
class SerialDevicePortT {
    constructor(port = null) {
        this.port = port;
    }
    pack(builder) {
        const port = (this.port !== null ? builder.createString(this.port) : 0);
        return SerialDevicePort.createSerialDevicePort(builder, port);
    }
}
exports.SerialDevicePortT = SerialDevicePortT;
